import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import WheelInput from '../../../Common/wheelInput';
import EmployeeDragable from './employeeDragable';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';

class Employee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nightHours: this.props.employee.nightHours ? this.props.employee.nightHours : this.props.employee.absence || this.props.employee.hours ? 0 : this.props.routine,
      hours: this.props.employee.hours ? this.props.employee.hours : this.props.employee.absence || this.props.employee.nightHours ? 0 : this.props.routine
    }
  }
  shouldComponentUpdate = (nextProps, nextState) => {
    // eslint-disable-next-line
    return (nextProps.isActive != this.props.isActive ||
      // eslint-disable-next-line
      nextProps.employee.hours != this.props.employee.hours ||
      // eslint-disable-next-line
      nextProps.employee.nightHours != this.props.employee.nightHours ||
      // eslint-disable-next-line            
      nextProps.employee.activities.length != this.props.employee.activities.length ||
      // eslint-disable-next-line            
      nextProps.isNight != this.props.isNight ||
      // eslint-disable-next-line            
      nextState.nightHours != this.state.nightHours ||
      // eslint-disable-next-line            
      nextState.hours != this.state.hours ||
      // eslint-disable-next-line            
      nextProps.employeesIsFetching != this.props.employeesIsFetching ||
      // eslint-disable-next-line            
      nextProps.employee.absence != this.props.employee.absence ||
      // eslint-disable-next-line            
      nextProps.index != this.props.index)
  };
  componentWillMount = () => {
    this.setDropped(this.props.employee.activities);
  };
  componentWillReceiveProps = (nextProps) => {
    //on reset set dropped again
    if (!nextProps.employeesIsFetching && this.props.employeesIsFetching) {
      this.setDropped(nextProps.employee.activities);
      this.setState({
        nightHours: nextProps.employee.nightHours ? nextProps.employee.nightHours : nextProps.employee.absence ? 0 : nextProps.routine
      })
      this.setState({
        hours: nextProps.employee.hours ? nextProps.employee.hours : nextProps.employee.absence ? 0 : nextProps.routine
      })
    }
    else {

      //set state hours
      // eslint-disable-next-line      
      if (nextProps.employee.nightHours != this.props.employee.nightHours || nextProps.employee.absence != this.props.employee.absence) {
        this.setState({
          nightHours: nextProps.employee.nightHours ? nextProps.employee.nightHours : nextProps.employee.absence ? 0 : nextProps.routine
        })
      }
      // eslint-disable-next-line      
      if (nextProps.employee.hours != this.props.employee.hours || nextProps.employee.absence != this.props.employee.absence) {
        this.setState({
          hours: nextProps.employee.hours ? nextProps.employee.hours : nextProps.employee.absence ? 0 : nextProps.routine
        })
      }
    }
    //set state hours if oposite has changed
    if (nextProps.employee.nightHours && !nextProps.employee.hours) {
      this.setState({
        hours: 0
      })
    }
    if (!nextProps.employee.nightHours && nextProps.employee.hours) {
      this.setState({
        nightHours: 0
      })
    }

  };
  setDropped = (activities) => {
    const { setDroppedEmployee, employee } = this.props;
    activities.forEach((activity) => {
      setDroppedEmployee(activity.id, employee.id)
    })
  };
  onWheelChange = (val) => {
    if (this.props.isNight) {
      //if employee does already have hours registered, set them
      if (this.props.employee.nightHours >= 0) {
        this.props.setEmployeeHours(this.props.index, val, true)
      }
      //if tempval is 0 and there is no activities on the employee set absence for him
      // eslint-disable-next-line      
      if (val == 0 && this.props.routine != 0) {
        this.props.setEmployeeAbsence(this.props.index, this.props.employee.activities, this.props.employee.id)
      }
      this.setState({
        nightHours: val
      })
    }
    else {
      //if employee does already have hours registered, set them
      if (this.props.employee.hours >= 0) {
        this.props.setEmployeeHours(this.props.index, val)
      }
      //if tempval is 0 and there is no activities on the employee set absence for him
      // eslint-disable-next-line      
      if (val == 0 && this.props.routine != 0) {
        this.props.setEmployeeAbsence(this.props.index, this.props.employee.activities, this.props.employee.id)
      }
      this.setState({
        hours: val
      })
    }
  };
  getButtonContent = () => {
    // eslint-disable-next-line    
    if (this.props.employee.absence != null && this.props.employee.activities.length == 0) {
      return <i className="fa fa-calendar-times-o" style={styles.absenceIcon} aria-hidden="true"></i>
    }
    return this.props.isNight ? this.state.nightHours : this.state.hours
  };
  render() {
    const { employee, setAsActive, isActive, isNight, setEmployeeIsDragging, index } = this.props;
    return (
      <div style={styles.container}>
        <div onClick={() => setAsActive(employee.id)}>
          <div
            className="col-xs-10 waves-btn"
            onClick={this.click}
            style={[
              styles.employeeName,
              // eslint-disable-next-line              
              (employee.absence != null || employee.activities.length > 0) && styles.employeeActive,
              isActive && styles.employeeOpen]
            }>
            <EmployeeDragable
              employee={employee}
              isNight={isNight}
              hours={isNight ? this.state.nightHours : this.state.hours}
              setEmployeeIsDragging={setEmployeeIsDragging}
              index={index}
              // eslint-disable-next-line              
              isActive={employee.absence != null || employee.activities.length > 0}
              employeeId={employee.id}
              canDrag={this.employeeCanBeDragged}
              setAsActive={setAsActive}
              getButtonContent={this.getButtonContent}
              isOpen={isActive}
            />
            {employee.name}
          </div>
          <div className="col-xs-2" style={styles.hourButtonContainer}>
            <button style={styles.button} className="btn btn-primary btn-block">
              {this.getButtonContent()}
            </button>
          </div>
        </div>
        {isActive ?
          <div>
            <div className="col-xs-12" style={styles.wheelContainer}>
              <WheelInput
                minValue={0}
                maxValue={24}
                interval={0.5}
                defaultValue={isNight ? this.state.nightHours : this.state.hours}
                onChange={this.onWheelChange}
                ulStyles={isNight ? { color: semanticColors.default } : null}
                overLayColor={isNight ? 'linear-gradient(to right, rgba(43,70,85,1) 2%,rgba(43,70,85,1) 6%,rgba(43,70,85,0) 50%,rgba(43,70,85,1) 92%,rgba(43,70,85,1) 200%)' : null}
              />
            </div>
          </div>
          : null}
      </div>
    );
  }
}

var styles = {
  container: {
    textAlign: 'center',
    lineHeight: '35px',
    cursor: 'pointer'
  },
  absenceButtonContainer: {
    marginTop: '12px',
    padding: '0'
  },
  wheelContainer: {
    padding: '0',
    marginTop: '12px'
  },
  absenceIcon: {
    fontSize: 18
  },
  employeeName: {
    textAlign: 'left',
    marginTop: '12px',
    padding: '0 5px 0 40px',
    backgroundColor: greyScaleColors.greyLighter,
    height: '40px',
    lineHeight: '40px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    borderTopLeftRadius: '2px',
    borderTopRightRadius: '0px',
    borderBottomRightRadius: '0px',
    borderBottomLeftRadius: '2px'
  },
  employeeActive: {
    backgroundColor: semanticColors.infoLight
  },
  employeeOpen: {
    backgroundColor: semanticColors.mainBackground
  },
  hourButtonContainer: {
    padding: '0',
    marginTop: '12px'
  },
  button: {
    height: '40px',
    padding: '0',
    borderTopLeftRadius: '0',
    borderBottomLeftRadius: '0',
    borderTopRightRadius: '2px',
    borderBottomRightRadius: '2px'
  }
}
Employee.propTypes = {
  employee: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    hours: PropTypes.number,
    nightHours: PropTypes.number,
    activities: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      hours: PropTypes.number
    })).isRequired,
    absence: PropTypes.shape({
      date: PropTypes.object.isRequired,
      hours: PropTypes.number.isRequired,
      absenceCode: PropTypes.string
    })
  }).isRequired,
  routine: PropTypes.number.isRequired,
  setAsActive: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  setEmployeeIsDragging: PropTypes.func.isRequired,
  setEmployeeHours: PropTypes.func.isRequired,
  setDroppedEmployee: PropTypes.func.isRequired,
  isNight: PropTypes.bool.isRequired,
  employeesIsFetching: PropTypes.bool.isRequired,
  setEmployeeAbsence: PropTypes.func.isRequired
};
export default Radium(Employee)


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/Sidebar/employee.jsx